const OnlyHeader = () => {
  return (
    <>
      <div className="header pb-8 pt-5 pt-md-8"></div>
    </>
  );
};

export default OnlyHeader;
